import type {NavLinksGroupSlice, NavLinksGroupSliceV2} from 'prismicio-types'
import {memo} from 'react'
import type {Context} from 'src/common/types'
import {NavLinksGroupDefault} from './Default'
import {NavLinksGroupVariationV2} from './VariationV2'

type NavLinksGroupProps = {
  context: Context
  slice: NavLinksGroupSlice
  index: number
}

const NavLinksGroup = ({context, slice, index: componentIndex}: NavLinksGroupProps) => {
  if (context.isFooterV2 || slice.variation === 'v2') {
    return <NavLinksGroupVariationV2 context={context} slice={slice as NavLinksGroupSliceV2} index={componentIndex} />
  }

  if (slice.variation === 'default' && context.isFooter) {
    return <NavLinksGroupDefault context={context} slice={slice} index={componentIndex} />
  }

  return null
}

export default memo(NavLinksGroup)
